import BrandGrid from './BrandGrid';
import { BrandImage } from 'API';
import debug from 'debug';
import { LOG_TIMING } from 'environment';
import {
  // getAllBrands,
  getBrandsCached,
} from 'lib/graphql';
import React, { useState, useEffect } from 'react';

const d = debug('dynamicBrandList');

interface DynamicBrandListProps {
  items: string;
  title?: string;
  buttonTitle?: string;
  addImageTitle?: boolean;
}

const DynamicBrandList: React.FC<DynamicBrandListProps> = ({ title, items, buttonTitle, addImageTitle = false }) => {
  const [displayBrands, setDisplayBrands] = useState<BrandImage[]>([]);
  if (true) d('showingBrands', items);
  useEffect(() => {
    const loadBrands = async () => {
      if (LOG_TIMING) console.time('loadBrands');
      const dynamicList = await getBrandsCached(items.split(','));
      if (LOG_TIMING) console.timeEnd('loadBrands');
      // @ts-ignore
      if (dynamicList && dynamicList.length) setDisplayBrands(dynamicList);
    };
    loadBrands();
  }, [items]);

  return <BrandGrid title={title} buttonTitle={buttonTitle} items={displayBrands} addImageTitle={addImageTitle} />;
};

export default DynamicBrandList;
